import { Container } from '@mui/system'
import React, { useEffect } from 'react'
import HeaderBannerPages from '../../Components/Sections/HeaderBannerPages/HeaderBannerPages'
import './WebsiteTerms.css'
function WebsiteTerms() {
    useEffect(() => {
        window.scrollTo(0,0)
        }, [])
  return (
    <>
      <HeaderBannerPages text="Website Terms" />
    <Container>
        <p className='termsMainPara rubik-regular-moufit'>
        THESE PLATFORM TERMS & CONDITIONS OF USE REGULATE YOUR USE OF THE MOUFIT WEBSITE AT HTTPS://WWW.MOU.FIT/AE-EN/ AND/OR THE MOUFIT APP. PLEASE READ THEM CAREFULLY BEFORE CONTINUING TO USE THE MOUFIT WEBSITE AND/OR THE MOUFIT APP.

1. CONSENT
<br/>
1.1 By continuing to Use the Platform, You acknowledge and agree that You have read, understood, accepted and agreed with these Platform T&Cs.
<br/>
1.2 You acknowledge and agree that if You did not positively agree to these Platform T&Cs then We are unable to, and do not intend for You, to have access to the Platform and any content and/or services that comprised and/or offered therein.
<br/>
2. PARTIES
<br/>
2.1 Moufit DMCC is a DMCC Free Zone company incorporated under the laws of Dubai, United Arab Emirates with business licence number DMCC179386 (“MouFit”, “We”, “Our”, “Us”) and having its principal place of business at Office 106, The Binary, Al Abraj Street, Business Bay, P.O. Box 413383, Dubai, United Arab Emirates.
<br/>
2.2 Moufit is the owner and/or licensor of the Platform and are in the business of providing the Services.
<br/>
2.3 You are the natural person who is Using the Platform in Your own individual capacity and/or on behalf of a company (“You”).
<br/>
3. PLATFORM TERMS & CONDITIONS OF USE
<br/>
3.1 You acknowledge and agree that these Platform T&Cs strictly govern Your access to and Use of the Platform, including access to the Services that We offer via the Platform.
<br/>
3.2 By using the Platform, You acknowledge and agree that You:
<br/>
3.2.1 understand and unconditionally accept these Platform T&Cs;
<br/>
3.2.2 shall at all times comply with the Platform T&Cs; and
<br/>
3.2.3 accept Moufit’s Privacy Policy.
<br/>
3.3 If You do not accept and agree to these Platform T&Cs, You acknowledge and agree that You shall not Use the Platform.
<br/>
4. RIGHT TO USE
<br/>
4.1 Subject to this Clause 4, Moufit hereby grants You a revocable, royalty-free, non-exclusive, non-transferable licence to Use:
<br/>
4.1.1 the Platform to utilise the services facilitated by the same;
<br/>
4.1.2 any content, information and related materials that may be made available through the Platform;
<br/>
4.1.3 the Platform for Your normal business purposes and/or personal use; and
<br/>
4.1.4 the Platform strictly in compliance with these Platform T&Cs.
<br/>
4.2 The licence in Clause 4.1 is strictly conditional on Your strict compliance with these Platform T&Cs.
<br/>
4.3 You acknowledge and agree that You shall not (and shall not permit anyone else to):
<br/>
4.3.1 reproduce, modify, distribute, transmit, post or disclose any Platform content without Moufit’s prior written approval which may be withheld in Moufit’s sole and absolute discretion;
<br/>
4.3.2 modify the Platform in any way;
<br/>
4.3.3 remove any copyright, trademark or other proprietary notices displayed on the Platform;
<br/>
4.3.4 Use any part of the content on the Platform for commercial purposes without obtaining a licence to do so from Moufit or its licensor;
<br/>
4.3.5 modify the paper or digital copies of any materials You have printed off or downloaded in any way;
<br/>
4.3.6 using any illustrations, photographs, video or audio sequences or any graphics separately from any accompanying text;
<br/>
4.3.7 trying to gain access to any other area of the Platform by hacking, password “mining” or any other illegitimate means;
<br/>
4.3.8 link to, mirror or frame any part of the Platform;
<br/>
4.3.9 pretending You are or impersonating another individual;
<br/>
4.3.10 Using the Platform or any Platform content for any unlawful activity or any activity prohibited by these Platform T&Cs;
<br/>
4.3.11 Using the Platform in any manner which may be prejudicial to Moufit, including without limitation:
<br/>
(a) to develop, offer or engage in the performance of any services which compete (whether directly or indirectly) with the Services;
<br/>
(b) for any purpose other than to utilise the Services; and
<br/>
(c) in such manner as to exclude Moufit from any payments it may be entitled to for providing the Services;
<br/>
4.4 Where You breach these Platform T&Cs, Your right to Use the Platform shall cease immediately.
<br/>
5. INTELLECTUAL PROPERTY
<br/>
5.1 You acknowledge and agree that You shall not (and shall not permit any others to) reproduce, modify, distribute, post, disclose or otherwise take or use Moufit’s IPR.
<br/>
5.2 The Platform and all rights therein are and shall remain the property of Moufit or its licensors.
<br/>
5.3 Neither these Platform T&Cs nor Your Use of the Platform shall convey or grant to You any rights:
<br/>
5.3.1 in or related to the Platform, except for the limited licence granted in Clause 4; or
<br/>
5.3.2 to use or reference in any manner the Marks of Moufit or its licensors.
<br/>
5.4 All content and functionality on the Platform are the exclusive property of Moufit or its licensors.
<br/>
5.5 The Marks displayed on the Platform are IPR owned by Moufit and/or its licensors. You shall not use or reproduce any Marks of, or imply any endorsement by or relationship with, Moufit or its licensors.
<br/>
6. WARRANTIES & REPRESENTATIONS
<br/>
6.1 You warrant and represent to Us as at the Agreement Date and at all times during the validity of these Platform T&Cs that You shall not (and shall not permit anyone else to):
<br/>
6.1.1 reproduce, modify, distribute, post, disclose or otherwise take or use Our IPR; and
<br/>
6.1.2 breach any of the terms of these Platform T&Cs.
<br/>
6.2 You acknowledge and agree that:
<br/>
6.2.1 the Platform and any Services accessible via the same are provided on an “as is” and “as available” basis;
<br/>
6.2.2 Moufit does not guarantee that the Platform, or any content on it, will be free from errors or omissions;
<br/>
6.2.3 Moufit cannot and does not guarantee that no Viruses will be transmitted or that no damage will occur to Your electronic device. Moufit is not responsible for any loss You may incur as a result of this; and
<br/>
6.2.4 the entire risk arising out of Your Use of the Platform remains solely with You, to the maximum extent permitted under applicable law.
<br/>
6.3 You acknowledge and that, insofar as permitted by applicable law, Moufit provides no warranties or representations to You whatsoever including that:
<br/>
6.3.1 the content on the Platform is accurate, complete or up to date;
<br/>
6.3.2 the Platform or any content, service or feature of the same shall be error-free or uninterrupted, or that any defects will be corrected; or
<br/>
6.3.3 the Platform will be accessible on any particular hardware or devices.
<br/>
6.4 Moufit and its third party content providers provide no warranties nor give any representations as to the ownership, accuracy or adequacy of the content on the Platform.
<br/>
6.5 Moufit excludes all conditions, warranties, representations or other terms which may apply to the Platform or any content on it to the maximum extent permitted by applicable law.
<br/>
7. LIABILITY
<br/>
7.1 Moufit shall not be liable to You for any loss or damage of any nature howsoever whether direct, indirect or consequential caused or arising under or in connection with:
<br/>
7.1.1 Your Use of, or inability to Use, the Platform;
<br/>
7.1.2 any information published on linked websites, contained in any user submissions published on the Platform, or provided by third parties.
<br/>
7.1.3 Your Use of or reliance on the Services made available via the Platform or Your inability to Use the Platform and/or access the Services (as the case may be); or
<br/>
7.1.4 any failure to provide the Platform and/or the Services, in part or in full, due to abnormal and unforeseen circumstances beyond Our control, including phone network failures or You being out of mobile coverage.
<br/>
7.2 This Clause 7 does not purport to exclude or limit liability that cannot be lawfully excluded or limited under applicable law.
<br/>
8. INDEMNITY
<br/>
8.1 You acknowledge and agree that You shall fully indemnify, defend and hold harmless Moufit from and against any and all claims and/or losses of whatever nature suffered, sustained or incurred, arising out of or in connection with:
<br/>
8.1.1 Your Use of the Platform;
<br/>
8.1.2 Your breach of these Platform T&Cs;
<br/>
8.1.3 Moufit’s use of any and all information that You post or otherwise publish on the Platform in any manner pursuant to its right under Clause 10.1; or
<br/>
8.1.4 violation of any third party rights.
<br/>
8.2 For the purposes of Clause 8.1, Moufit shall be deemed to include its affiliates, employees, agents, directors, shareholders and officers.
<br/>
9. VIRUSES
<br/>
9.1 Moufit does not guarantee that the Platform will be secure or free from bugs or Viruses.
<br/>
9.2 You shall not:
<br/>
9.2.1 misuse the Platform by knowingly introducing any Viruses;
<br/>
9.2.2 attempt to gain unauthorised access to the Platform, the server on which the Platform are stored or any server, computer or database connected to the Platform; or
<br/>
9.2.3 attack the Platform via a denial-of-service attack, a distributed denial-of-service attack or any other cyber-attack aimed to disrupt ordinary access to the Platform.
<br/>
9.3 You acknowledge and agree that any breach by You of Clause 9.2:
<br/>
9.3.1 shall be reported by Moufit to the relevant law enforcement authorities and Moufit shall cooperate with them by disclosing Your identity to them; and
<br/>
9.3.2 shall result in Your right to Use the Platform ceasing immediately and Moufit taking relevant proceedings against You.
<br/>
10. USER POSTINGS
<br/>
10.1 You acknowledge and agree that Moufit shall own and have the unrestricted right to use, publish, and otherwise exploit any and all information that You post or otherwise publish on the Platform in any manner.
<br/>
10.2 You waive any claims against Moufit for any alleged or actual infringements of any rights of privacy or publicity, moral rights, or rights of attribution in connection with Moufit's use of such submissions.
<br/>
10.3 You warrant and represent to Moufit that You will not post or publish on the Platform any materials that:
<br/>
10.3.1 are threatening, libellous, defamatory, obscene;
<br/>
10.3.2 would constitute, or that encourage conduct that would constitute, a criminal offense, give rise to civil liability, or otherwise violate law;
<br/>
10.3.3 infringe the IPR, privacy, or other rights of any third parties;
<br/>
10.3.4 contain a Virus;
<br/>
10.3.5 contain advertising; or
<br/>
10.3.6 constitute or contain false or misleading statements.
<br/>
10.4 Moufit does not and cannot review all information posted to the Platform by users and is not responsible for such information.
<br/>
10.5 Moufit reserves the right to refuse to post and the right to remove any information at any time.
<br/>
11. NETWORK ACCESS & DEVICES
<br/>
11.1 You acknowledge and agree that You are responsible for:
<br/>
11.1.1 obtaining the data network access necessary to Use the Platform, including all fees and charges associated with the same; and
<br/>
11.1.2 procuring compatible hardware or devices necessary to access the Platform.
<br/>
12. NOTICES OF INFRINGEMENT & TAKEDOWN
<br/>
12.1 Moufit does not allow and/or tolerate the posting of any information that infringes the IPR of any person or entity.
<br/>
12.2 Where You reasonably believe that Your IPR is infringed by any content on the Platform, please contact Moufit at the email address in Clause 15.20.
<br/>
12.3 For the purposes of Clause 12.2, You acknowledge and agree that You shall provide relevant details including identifying the work in which You are claiming IPR in, the allegedly infringing material, Your contact details and authorised signatory’s details.
<br/>
12.4 Moufit shall remove any posted submission that is established as infringing the IPR of any person or entity.
<br/>
13. THIRD PARTY WEBSITES / APPLICATIONS
<br/>
13.1 The Platform may contain links to independent third party websites and/or applications and may also contain content supplied by independent third parties.
<br/>
13.2 You acknowledge and agree that third party websites and/or applications to which the Platform contains links to are:
<br/>
13.2.1 not under Moufit’s control and Moufit has no responsibility for nor does it endorse their content;
<br/>
13.2.2 governed by their own terms and conditions and privacy policies and access to them is at Your own discretion.
<br/>
14. PLATFORM CONTENT
<br/>
14.1 You acknowledge and agree that We may update the Platform from time to time, and may change its content at any time.
<br/>
14.2 You acknowledge and agree that despite Our efforts certain content on the Platform may, from time to time, become out of date, and We shall take reasonable steps to update the same.
<br/>
14.3 Apple Inc. or Google Inc. do not have any responsibilities or obligations to You in relation to the App and will not provide any maintenance or support services for the App.
<br/>
15. GENERAL PROVISIONS
<br/>
15.1 You acknowledge and agree that You shall not refer to Moufit or its licensors in any public media for any purposes.
<br/>
15.2 You acknowledge and agree that:
<br/>
15.2.1 Moufit may revise these Platform T&Cs at any time without any need to seek Your approval; and
<br/>
15.2.2 any revisions of these Platform T&Cs shall be effective immediately upon Us notifying You.
<br/>
15.3 Your continued Use of the Platform shall be deemed an acceptance by You of these Platform T&Cs (as revised from time to time) pursuant to Clause 15.2.
<br/>
15.4 You will be able to view, and You agree to check each time You Use the Platform, the current version of these T&Cs.
<br/>
15.5 In accepting and agreeing these Platform T&Cs, You hereby warrant and represent to Moufit that You have the lawful capacity and authority needed for You to do so.
<br/>
15.6 You acknowledge and agree that Moufit can and will rely on the warranty and representation You provide to us at Clause 15.5.
<br/>
15.7 Both You and Moufit shall comply with all applicable law.
<br/>
15.8 Moufit may, in its sole and absolute discretion and at any time, modify, suspend or terminate operation of or access to the Platform (or any part thereof), including performing maintenance and updates.
<br/>
15.9 Neither You or Moufit shall be liable to the other (as the case may be) for any delay or non-performance of its obligations under these Platform T&Cs as a direct result of an established Force Majeure Event.
<br/>
15.10 These Platform T&Cs constitutes the entire agreement between You and Moufit relating to Your Use of the Platform, to the exclusion of all other terms and conditions, and any prior written or oral agreement between both parties.
<br/>
15.11 You may not assign, novate, or otherwise transfer all or any of Your rights, benefits or obligations under these Platform T&Cs without Moufit’s prior written approval
<br/>
15.12 Moufit may assign, transfer or deal in any way with its rights under these Platform T&Cs including to an affiliate or any third party.
<br/>
15.13 No failure to exercise, nor any delay in exercising, any right, power or remedy under these Platform T&Cs shall operate as or be deemed a waiver of the same. Waivers must always be given in writing.
<br/>
15.14 Any waiver of any breach of these Platform T&Cs shall not be deemed to be a waiver of any subsequent breach.
<br/>
15.15 Where any provision of these Platform T&Cs is determined to be invalid, illegal or void by any court or administrative body of competent jurisdiction, these Platform T&Cs shall be deemed modified to the minimum extent necessary to make them valid and enforceable.
<br/>
15.16 Where the deemed modification in Clause 15.10 is not possible, the relevant invalid, illegal or void provision(s) shall be deemed deleted and the rest of these Platform T&Cs shall still remain in full force and effect.
<br/>
15.17 You and Moufit are and shall remain independent parties and neither You nor Moufit shall have, or represent itself to have, any authority to bind the other party to act on its behalf.
<br/>
15.18 Nothing in these Platform T&Cs shall be construed to make either You or Moufit an agent, employee, franchisee, joint venture or legal representative of the other party.
<br/>
15.19 Except as expressly stated, these Platform T&Cs do not create any rights that are enforceable by any third party. You acknowledge and agree that You and Moufit have rights under these Platform T&Cs.
<br/>
15.20 All notices under these Platform T&Cs shall be in writing and shall be delivered by email to the party due to receive it at the party’s designated email address. In Moufit’s case, please send it to yalla@mou.fit.
<br/>
15.21 These Platform T&Cs are drawn up in the English language and the English language version of the same shall always prevail over any translation. These Platform T&Cs shall be construed, interpreted and administered in English.
<br/>
15.22 These Platform T&Cs are governed by, and shall be construed in accordance with the laws of the Emirate of Dubai and the Federal Laws of the United Arab Emirates applicable therein.
<br/>
15.23 Both You and Moufit irrevocably submit to the exclusive jurisdiction of the courts of the Dubai International Financial Centre, Dubai, United Arab Emirates in relation to any disputes.
<br/>
16. DEFINITIONS
<br/>
16.1 “Agreement Date” means the date on which You first Use the Platform.
<br/>
16.2 “App” means the moufit application downloadable via a relevant app store including those offered by Apple Inc. or Google Inc.
<br/>
16.3 “IPR” means patents, inventions (whether patentable or not), copyrights, moral rights, design rights, trade-marks, trade names, business names, service marks, brands, logos, service names, trade secrets, know-how, domain names, database rights and any other intellectual property or proprietary rights (whether registered or unregistered, and whether in electronic form or otherwise) including rights in computer software, and all registrations and applications to register any of the aforesaid items, rights in the nature of the aforesaid items in any country or jurisdiction, any rights in the nature of unfair competition rights, and rights to sue for passing off;
<br/>
16.4 “Force Majeure Event” means any unforeseeable event or occurrence which is beyond the reasonable control of a party and which prevents or delays that party from performing any or all of its obligations under these Platform T&Cs (e.g. acts of God, civil unrest, political situations etc.
    <br/>
16.5 “Marks” means company names, product and service names, trademarks, service marks, designs and logos.
<br/>
16.6 “Privacy Policy” means our privacy & cookie policy accessible at https://www.mou.fit/ae-en/.
<br/>
16.7 “Services” means the technology platform that enables Users of the Platform to arrange and schedule personal training and fitness-related services with independent third party providers.
<br/>
16.8 “Site” means the website at https://www.mou.fit/ae-en/.
<br/>
16.9 “Use” means using any of the Platform, including downloading, accessing, browsing, viewing or registering to use and utilising in any manner (as the case may be) the Platform either directly or indirectly (and “User” shall have the equivalent grammatical meaning).
<br/>
16.10 “Virus” means any viruses, worms, trojan horses, cancel bolts or any other computer code designed to disrupt or adversely impact computer systems, networks or devices.
<br/>
16.11 “Platform” means the Site and/or the App.
<br/>
16.12 “Platform T&Cs” means these general terms and conditions that govern Your access to and Use of the Platform.
        </p>
    </Container>
    </>
  )
}

export default WebsiteTerms